import { Component, OnDestroy } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import * as moment from 'moment';

@Component({
  selector: 'boxx-custom-date-popover',
  templateUrl: './custom-date-popover.component.html',
  styleUrls: ['./custom-date-popover.component.scss'],
})
export class CustomDatePopoverComponent implements OnDestroy {
  public maxDate = (Number(new Date().getFullYear())+1) + '-12-31';
  public customDate: any;
  public currentTime: any;

  public defaultDate: any;
  public defaultTime: any;

  public localeString: string;
  public customPres: string = 'date-time';
  public paramPres: string;
  public currentDate: string;

  public modalType = 1;
  minInsterval: number[];

  constructor(private modalCtrl: PopoverController) {}

  ngOnInit() {
    const minT = 0,
      maxT = 55,
      interval = 5;

    const length = (maxT - minT) / interval + 1;
    this.minInsterval = Array.from({ length }, (_, i) => minT + i * interval);
    if(this.customDate){
      console.log('hay customDate');
      this.defaultDate = this.customDate;
      //const splitTime = this.customDate.toString().split('T');
      //this.defaultTime = splitTime[1].slice(0, 5);//this.customDate;
    }
    else{
      this.currentDate = moment().add(1, 'days').format('YYYY-MM-DD')+ 'T01:01:01-01:00';
      //this.currentDate = moment().add(1, 'days').format("YYYY-MM-DD");
      this.defaultDate = this.currentDate;
      console.log('this.currentDate: ', this.currentDate);
      //const splitTime = this.currentDate.toString().split('T');
      //this.defaultTime = splitTime[1].slice(0, 5);
    }
   
    this.getLanguageApp();
    if(this.paramPres){
      this.customPres = this.paramPres;
    }
  }

  async getLanguageApp(){
    this.localeString = 'en-US';
  }

  ngOnDestroy() {}

  async close() {
    this.modalCtrl.dismiss();
  }

  selectDate() {
    console.log('this.defaultDate: ', this.defaultDate);

    //if(this.customPres === 'date'){
    this.modalCtrl.dismiss({
      cDate: this.defaultDate //+ 'T12:01:01-12:00'
    });
    //} 
    // else{
    //   const splitDate = this.defaultDate.toString().split('T');
    //   //const splitTime = this.defaultTime.toString().split('T');
    //   //console.log(splitDate[0]+'T'+this.defaultTime+':00-05:00');
    //   this.modalCtrl.dismiss({
    //     cDate: splitDate[0]+'T'+this.defaultTime+':00-05:00'
    //   });
    // }
  }

}
